import { Map } from 'immutable';
export const match = (actionDescription, reducer) => {
    return { actionDescription, reducer };
};
export const makeReducer = (reducerDescriptions, initialState) => {
    const reducerMap = Map().withMutations(map => {
        reducerDescriptions.forEach(reducerDescription => {
            map.set(reducerDescription.actionDescription.type, reducerDescription.reducer);
        });
    });
    return (state = initialState, action) => {
        const reducer = reducerMap.get(action.type);
        if (reducer) {
            return reducer(state, action);
        }
        else {
            return state;
        }
    };
};
